module.exports = __webpack_public_path__ + "54b88637bfb8d78658cf9906c0332480.png";